import { COLUMN_TYPES_ENUM, TIME_TYPE_COLUMNS } from 'modules/report/enums/columnTypeEnum';
import * as columnUnitTypes from 'modules/report/enums/columnUnitTypeEnum';
import { displayDateState } from 'modules/report/utils/columnHelper';

/**
 * @param {object} dateState
 *
 * @returns {*[]}
 */
export default dateState => [
    {
        id: 'scheduledUtilizationBetween',
        display: `Forecasted Utilization - ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.PERCENTAGE.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: true,
    },
    {
        id: 'scheduledUtilizationPrevious',
        display: `Forecasted Utilization - Previous ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.PERCENTAGE.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledUtilizationAfter',
        display: `Forecasted Utilization - Next ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.PERCENTAGE.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledAvailabilityBetween',
        display: `Forecasted Availability - ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: true,
    },
    {
        id: 'scheduledAvailabilityPrevious',
        display: `Forecasted Availability - Previous ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledAvailabilityAfter',
        display: `Forecasted Availability - Next ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledOvertimeBetween',
        display: `Scheduled Overtime - ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: true,
    },
    {
        id: 'scheduledOvertimePrevious',
        display: `Scheduled Overtime - Previous ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledOvertimeAfter',
        display: `Scheduled Overtime - Next ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledAvailabilityStatusBetween',
        display: `Forecasted Availability Status - ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledAvailabilityStatusPrevious',
        display: `Forecasted Availability Status - Previous ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledAvailabilityStatusAfter',
        display: `Forecasted Availability Status - Next ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledUtilizationStatusBetween',
        display: `Utilization Status - ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledUtilizationStatusPrevious',
        display: `Utilization Status - Previous ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledUtilizationStatusAfter',
        display: `Utilization Status - Next ${displayDateState(dateState)}`,
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledFTEUtilizationBetween',
        display: 'Scheduled FTE',
        unitType: columnUnitTypes.TIME.value,
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'capacity',
        columnType: COLUMN_TYPES_ENUM.CAPACITY,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: true,
    },
];
